import React from 'react'

import Grid from '@mui/material/Grid'
import { Text } from 'components/texts'
import { Input } from 'components/forms/components'
import { CursoEscolarSelect } from 'components/forms/components/Select/custom'

/**
 * Esta es la plantilla para cuando se busque por los datos basicos de la actividad
 */
export default function ProfesorTemplate({ register, errors, reset, setValue }) {

    return (
        <>
            <Grid container mt={2} mb={1}>
                <Text fontWeight={'bold'}>Según datos de:</Text><br />
            </Grid>

            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Input label="Primer apellido" width={"100%"} name={"apellido1_profesor"} register={register} errors={errors} />
                </Grid>

                <Grid item xs={6}>
                    <Input label="Segundo apellido" width={"100%"} name={"apellido2_profesor"} register={register} errors={errors} />
                </Grid>

                <Grid item xs={6}>
                    <Input label="Nombre" width={"100%"} name={"nombre_profesor"} register={register} errors={errors} />
                </Grid>

                <Grid item xs={6}>
                    <CursoEscolarSelect
                        name={"curso_escolar_id"}
                        register={register}
                        setValue={setValue}
                        errors={errors}
                        defaultValue={null}
                        wantToReset={reset}
                        searcheable />
                </Grid>
            </Grid>
        </>
    )
}

